import { ClientOnly } from '~/components/elements/ClientOnly'
import CookiebotDeclaration from '~/components/CookiebotDeclaration'
import type { Page_Flexcontent_Flex_CookiePolicy } from '~/graphql/types'

export default function CookiePolicy({ fields }: { fields: Page_Flexcontent_Flex_CookiePolicy }) {
  return (
    <section id="CookiePolicy">
      <div className="container xl:max-w-screen-xl py-10">
        <ClientOnly>{() => <CookiebotDeclaration />}</ClientOnly>
      </div>
    </section>
  )
}
